import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

const useAddDocsToMatter = (matterId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const addDocs = async () => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
    });

    const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/add-docs`, fetchConfig);
    if (!response.ok) {
      // Extract error message from backend response
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Failed to add documents');
    }
    return await response.json();
  };

  return useMutation({
    mutationFn: addDocs,
    onSuccess: () => {
      queryClient.invalidateQueries([QueryEntity.Files, { matterId }]);
    },
    onError: (error: Error) => {
      console.error('Add docs error:', error);
      toast.error(error.message || 'Failed to add documents. Please try again.');
    },
  });
};

export default useAddDocsToMatter;
